/**
 * 定义路由
 * 每个路由的第一个参数是ctx：上下文
 */

export default {
  // 获取项目
  getCollaterals: async (ctx, data, enums) => {
    const collaterals = await ctx.controller.collateral.getAll(data, enums);

    return collaterals;
  }
};
